import { Link } from "react-router-dom";

const PartnerCTA = () => (
  <section className="py-10 md:py-12 border-t border-border">
    <div className="container">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="font-display text-2xl">Work with the athletes</h2>
          <p className="text-sm text-muted-foreground mt-1 max-w-xl">
            Brands, teams and organizers: reach out about partnerships, appearances and collaborations.
          </p>
        </div>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center min-h-[44px] px-6 py-3 rounded-full border border-border text-sm font-semibold hover:border-secondary transition-colors whitespace-nowrap"
        >
          Get in touch →
        </Link>
      </div>
    </div>
  </section>
);

export default PartnerCTA;
